export const mapColors = {
  background: '#E4E4E4',
  foreground: '#2F3580',
};
